module.exports = __webpack_public_path__ + "media/images/products/products/b3-73f9faa6128fa33e8e94c3f61d4b1fb9.jpg";